import React, { forwardRef } from "react";
import ReactDatePicker from "react-datepicker";
import {
  CANTIDAD_ANIOS_DESPLEGABLE,
  FORMATO_FECHA_INPUT_DEFAULT,
  normalizarEventoFechaInput,
  normalizarFormatoFechaInput,
  resolverFechaMinimaInput,
} from "../helper/dateInput";

const DatePickerInput = forwardRef(
  (
    {
      dateFormat = FORMATO_FECHA_INPUT_DEFAULT,
      fechaMinima,
      minDate,
      onChangeRaw,
      showYearDropdown = true,
      scrollableYearDropdown = true,
      yearDropdownItemNumber = CANTIDAD_ANIOS_DESPLEGABLE,
      ...props
    },
    ref,
  ) => {
    const handleChangeRaw = (evento, ...args) => {
      normalizarEventoFechaInput(evento);
      if (onChangeRaw) onChangeRaw(evento, ...args);
    };

    return (
      <ReactDatePicker
        ref={ref}
        {...props}
        dateFormat={normalizarFormatoFechaInput(dateFormat)}
        minDate={resolverFechaMinimaInput(fechaMinima, minDate)}
        onChangeRaw={handleChangeRaw}
        showYearDropdown={showYearDropdown}
        scrollableYearDropdown={scrollableYearDropdown}
        yearDropdownItemNumber={yearDropdownItemNumber}
      />
    );
  },
);

DatePickerInput.displayName = "DatePickerInput";

export default DatePickerInput;
